export default [
    {
        id: 1,
        title: '前台',
        detail: [
            { img: 'booth-front.jpg' },
            { p: '领取精美赠品，或与现场工作人员取得联系。' }
        ],
        link:''
    },
    {
        id: 2,
        title: 'Yamaha Day',
        detail: [
            { img: 'booth-yamahaday.jpg' },
            { p: '近距离接触雅马哈摩托车MT-09，感受两种雅马哈的同一种激情。' }
        ],
        link:''
    },
    {
        id: 3,
        title: '电子键盘',
        detail: [
            { img: 'booth-ekb.jpg' },
            { p: '请前往展位体验。' }
        ],
        link:'#product'
    },
    {
        id: 4,
        title: '钢琴',
        detail: [
            { img: 'booth-piano.jpg' },
            { p: '请前往展位体验。' }
        ],
        link:'#product'
    },
    {
        id: 5,
        title: '概念乐器展示',
        detail: [
            { img: 'booth-concept.jpg' },
            { p: '汇聚来自海外设计师的概念款乐器，让熟悉的黑白键焕发新生。' }
        ],
        link:''
    },
    {
        id: 6,
        title: '钢琴AI舞台',
        detail: [
            { img: 'booth-aipiano.jpg' },
            { p: '结合雅马哈自动演奏钢琴与全新人工智能伴奏技术，实现默契的“人机合奏。' }
        ],
        link:'#schedule'
    },
    {
        id: 7,
        title: '管弦乐器',
        detail: [
            { img: 'booth-wind.jpg' },
            { p: '由雅马哈匠人现场演示高端萨克斯雕刻，配合摄影机放大细节。<br />「萨克斯雕刻演示」<br />10月10日-12日：10:00-11:30、13:30-14:30、15:00-16:30<br />10月13日：10:00-11:30<br /><br />※管乐器体验请自备吹嘴。' }
        ],
        link:'#product'
    },
    {
        id: 8,
        title: '主舞台',
        detail: [
            { img: 'booth-stage.jpg' },
            { p: '从戴上耳机欣赏的“静音乐队”，到近距离接触的艺术家演奏，在展位中央的主舞台感受接连不断的音乐盛宴。' }
        ],
        link:'#schedule'
    },
    {
        id: 9,
        title: '无人乐队',
        detail: [
            { img: 'booth-band.jpg' },
            { p: '钢琴、爵士鼓、低音提琴，都能“自动演奏”？「无人乐队」中国首秀，跟随这支看不见的乐队感受科技与音乐的融合。' }
        ],
        link:'#schedule'
    },
    {
        id: 10,
        title: '电声乐器',
        detail: [
            { img: 'booth-combo.jpg' },
            { p: '请前往展位体验。' }
        ],
        link:'#product'
    },
    {
        id: 11,
        title: 'HIFI体验区',
        detail: [
            { img: 'booth-hifi.jpg' },
            { p: '请前往展位体验。' }
        ],
        link:'#product'
    },
    {
        id: 12,
        title: '高端钢琴智慧展厅',
        detail: [
            { img: 'booth_smartpiano.jpg' },
            { p: '雅马哈高端钢琴智慧展示厅从经久不衰的音乐会三角钢琴，到融合全新科技的跨界钢琴，在这间沙龙中充分感受雅马哈钢琴的魅力。' }
        ],
        link:'#product'
    },

]